export const mainShadow = "0 2px 8px 0 rgba(0, 0, 0, 0.10)";
